export const ACTION_FETCH = 'fetch';
export const SET_SHEDULE = 'setShedule';
export const SET_TIME_PERIODS_BY_DATES = 'setTimePeriodByDate';
export const SET_CHILDREN = 'setChildren';
export const REMOVE_CHILDREN = 'removeChildren';
export const ADD_CHILDREN = 'addChildren';
export const SET_FORM_DATA = 'setActivityData';
export const SEND_ACTIVITY_ORDER = 'sendActivityOrder';
export const SET_ACTIVITIES = 'setActivities';
export const STORE_MODULE_NAME = 'activityCard';




// WEBPACK FOOTER //
// ./src/pages/activities/card/const.ts